import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  text-align: left;

  color: #1A436F;
  text-transform: uppercase;

  .header {
    margin-bottom: 10px;

    img {
      width: 12%;
      margin-right: 15px;
    }

    h2 {
      font-size: 30px;
      margin-bottom: 25px;
    }
  }

  h1 {
    font-size: 36px;
  }


  div {
    display: flex;
    align-items: center;
  }

  @media only screen and (max-width: 767px) {
    .header {
      margin: 20px 0;
      img {
        display: none !important;
      }
      h1 {
        margin: 10px 0;
        font-size: 1.75rem;
      }
    }
  }

`;

export const Form = styled.form`
  div {
    align-items: flex-start;
  }

  @media only screen and (max-width: 767px) {
    div {
      display: block;
      width: 90%;
      margin: 0 auto;
    }
    input {
      margin-bottom: 10px;
    }
  }
`;

export const ControlsWrapper = styled.div`
  display: flex !important;
  justify-content: flex-end; 
  align-items: center !important;
  margin: 10px auto; 
  @media only screen and (max-width: 767px) {
    width: 90% !important;
    button {
      margin: 15px;
    }
  }
`;
